/* eslint-disable react/react-in-jsx-scope */
import React from "react";
import CardIcon from "../components/icons/CardIcon";
import AchIcon from "../components/icons/AchIcon";
import WireIcon from "../components/icons/WireIcon";
import UpiIcon from "../components/icons/UpiIcon";
import NetbankingIcon from "../components/icons/NetBankingIcon";
import WalletIcon from "../components/icons/WalletIcon";
import TransferIcon from "../components/icons/TransferIcon";
import GooglePay from "../components/icons/GooglePay";
import InstantPay from "../components/icons/InstantPayIcon";
import RtgsChallan from "../components/icons/RtgsChallan"
import Gpay from "../components/icons/Gpay"

export default (tabs) => {
  if (tabs) {
    let menutab = tabs.reduce(function (tab, name) {
      let tabIcon;
      let title;
      if (name === 'ACH') {
        tabIcon = <AchIcon />;
        title = 'BANK';
      } else if (name === 'CARD') {
        tabIcon = <CardIcon />;
        title = 'CARD';
      } else if (name === 'ACH_LEGACY') {
        tabIcon = <AchIcon />;
        title = 'ACH';
      } else if (name === 'UPI') {
        tabIcon = <UpiIcon />;
        title = 'UPI';
      } else if (name === 'WIRE') {
        tabIcon = <WireIcon />;
        title = 'WIRE';
      } else if (name === 'NET_BANKING') {
        tabIcon = <NetbankingIcon />;
        title = 'NET BANKING';
      } else if (name === 'WALLET') {
        tabIcon = <Gpay/>;
        title =  '\u200B';
      } else if (name === 'GOOGLE_PAY_US') {
        tabIcon = <Gpay />;
        title = '\u200B';
      } else if (name === 'INSTANT_PAYMENT') {
        tabIcon = <InstantPay />;
        title = 'INSTANT PAYMENT';
      } else if (name === 'SWIREPAY_US') {
        tabIcon = <InstantPay />;
        title = 'SWIREPAY WALLET';
      } else if (name === 'TRANSFER') {
        tabIcon = <TransferIcon />;
        title = 'TRANSFER';
      }
       else if (name === 'CHALLAN') {
        tabIcon = <RtgsChallan />;
        title = 'CHALLAN';
      }
      tab.push({ name: title, icon: tabIcon, disabled: false });
      return tab;
    }, [])
    return menutab;
  } else {
    let tab = [];
    let tabIcon = <CardIcon />;
    let title = 'CARD';
    tab.push({ name: title, icon: tabIcon, disabled: false });
    return tab;
  }
};